<template>
  <v-sheet class="clickable background pa-5 no-shadow" rounded color="">
    <v-row class="text-h6 fontGrey--text font-weight-medium ">
      <span>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              large
              :color="iconColor(item.disposition, item.origination)"
              >{{ callIcon(item.origination) }}</v-icon
            >
          </template>
          <span>{{ tooltipContent(item.disposition, item.origination) }}</span>
        </v-tooltip>
      </span>
      <p v-if="item.origination" class="font-weight-bold mb-0">
        <span>
          {{ item.destination | formatedPhone }}
          <span class="font-weight-regular text-body-1"> שיחה מ </span>
          <span class="font-weight-regular text-h6">
            {{ item.clid | formatedPhone }}
          </span>
        </span>
      </p>
      <p v-else class="font-weight-bold mb-0">
        <span>
          {{ item.clid | formatedPhone }}
          <span class="font-weight-medium text-body-1"> שיחה ל </span>
          <span class="font-weight-medium text-h6">
            {{ isCallToApp | formatedPhone }}
          </span>
        </span>
      </p>
      <p class="mb-0">
        <span class="text-body-1 fontDarkGrey--text pr-5">
          {{ formatedDate(item.date) }}
        </span>
        <span class="text-body-1 fontDarkGrey--text pr-3">
          {{ callLength(item) }}
        </span>
      </p>
    </v-row>
  </v-sheet>
</template>

<script>
import parseInt from "lodash/parseInt";
import isNumber from "lodash/isNumber";
import replace from "lodash/replace";

export default {
  name: "CallReportItem",
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  computed: {
    isCallToApp() {
      console.log(
        " ? ",
        parseInt(this.item.destination),
        isNumber(parseInt(this.item.destination))
      );
      return isNumber(parseInt(this.item.destination))
        ? "אפליקציה"
        : this.item.destination;
    },
  },
  methods: {
    callIcon(callOrigin) {
      return callOrigin
        ? "mdi-arrow-top-right-thin"
        : "mdi-arrow-bottom-left-thin";
    },
    iconColor(callDispo, callOrigin) {
      switch (callDispo) {
        case "DELIVERED":
        case "ANSWERED":
          return callOrigin ? "blue" : "success";
        case "NO ANSWER":
          return callOrigin ? "orange" : "error";
        case "FAILED":
          return callOrigin ? "orange" : "error";
        default:
          return "blue";
      }
    },
    tooltipContent(callDispo, callOrigin) {
      switch (callDispo) {
        case "DELIVERED":
        case "ANSWERED":
          return callOrigin ? "שיחה יוצאת שנענתה" : "שיחה נכנסת שנענתה";
        case "NO ANSWER":
          return callOrigin ? "שיחה יוצאת שלא נענתה" : "שיחה נכנסת שלא נענתה";
        case "FAILED":
          return callOrigin ? "שיחה יוצאת שלא התחברה" : "שיחה נכנסת שלא התחברה";
        default:
          return "blue";
      }
    },
    formatedDate(date) {
      return replace(date.substr(0, 19), "T", " "); //date.toUTCString()
    },
    callLength(call) {
      return (call.billsec / 60).toFixed(1) + " דקות ";
    },
  },
};
</script>
